import { useDeleteSource } from '../hooks/useDeleteSource';
import { ConfirmDialog } from '@/shared/components/ahkinia/ConfirmDialog/ConfirmDialog';

interface DeleteSourceModalProps {
  sourceId: string;
  sourceName: string;
  open: boolean;
  onClose: () => void;
}

export function DeleteSourceModal({ sourceId, sourceName, open, onClose }: DeleteSourceModalProps) {
  const { deleteSource, isDeleting } = useDeleteSource();

  const handleConfirm = () => {
    deleteSource(sourceId, {
      onSuccess: () => {
        onClose();
      },
    });
  };

  return (
    <ConfirmDialog
      open={open}
      onOpenChange={(v) => !v && onClose()}
      title="Eliminar fuente"
      description={
        <span data-testid="delete-source-message">
          ¿Estás seguro de eliminar la fuente <strong>{sourceName}</strong>?
        </span>
      }
      onConfirm={handleConfirm}
      confirmLabel="Eliminar"
      confirmLoadingLabel="Eliminando..."
      isPending={isDeleting}
      data-testid="delete-source-modal"
    >
      <div className="p-3 bg-destructive/10 border border-destructive/30 rounded-md">
        <p className="text-sm text-destructive font-medium">
          Esta acción es irreversible y eliminará la configuración, pero mantendrá los datos
          históricos ingestados.
        </p>
      </div>
    </ConfirmDialog>
  );
}
